module.exports = {
  siteTitle: 'Mudassir Ijaz Portfolio',
  manifestName: 'Resume',
  manifestShortName: 'Landing',
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-resume/`,
  firstName: 'Mudassir',
  lastName: 'Ijaz',
  joiningCompany: 'Google',
  currentCompany: 'kwanso',

  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/mudassirijaz786',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/mudassirijaz786/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/mudassirijaz786',
    },
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://www.facebook.com/mudassirijaz786',
    },
  ],
  projects: [
    {
      title: 'RealREPP',
      links: [
        'https://realrepp.com/',
        'https://www.linkedin.com/company/realrepp/',
      ],
      description: [
        `RealREPP (Activate Your AI-Powered Job Search Here). RealREPP is a fully functional recruitment portal.`,
        `It assists job seekers to land their ideal positions. We're currently working on an applicant tracking system (ATS)
      for this application, which acts as a job board.`,
        `For staffing firms and in-house corporate hiring teams, JobAdder is a cloud-based recruitment management
      software`,
        `NodeJs, ExpressJs, GraphQL(schema first approach), ReactJs, Sequilize, and PostgreSQL are among the
      technologies used in the current version of RealREPP. Using our exclusive search algorithms, find suitable jobs.`,
        `With customized job Search Automation and RealREPP Expert Recruiters, RealREPP makes the process easier
      for you.`,
        `NestJs, ReacJs, Typescript, GraphQL, DocuSign, Interseller, PostgreSQL, TypeORM, AWS, Google cloud platform,
      Elastic searching, Redis, and Google maps as tech stack.`,
      ],
      from: '2020',
      to: 'Present',
    },

    {
      title: 'Intentsify',
      links: [
        'https://intentsify.io/',
        'https://intentsify.io/intent-activation-software/',
      ],
      description: [
        `Intentsify automates the way B2B marketers aggregate, analyze, and act on prospects' buying signals by turning
        intent data into actionable information.`,
        `Intent Activation™, a new category of intent-driven technology, is designed to increase the effect of intent data,
        allowing you to boost demand and pipeline velocity while saving time and money.`,
        `Some stats are Intent Signals/Month 50B+, Identified In-Market Target Accounts 4.2M, B2B Content Sites 5k+.`,
        `It uses Node, React, TypeScript, Sequelize ORM, Redux.`,
      ],
      from: '2020',
      to: 'Present',
    },
    {
      title: `KHMC & DHR`,
      links: [
        'https://www.linkedin.com/company/khmc/',
        'http://khmc.jo/en/home/',
      ],
      description: [
        `Al Khalidi Hospital was established to assist patients with financial matters, scheduling appointments, acquiring
      visas, reserving hotels, and arranging transportation.`,
        `Worked as part of a team to develop a web-based solution for KHMC's internal use in the hospital. As a result,
      we devised a method for their use; according to calculations, there were half a million records in SQL databases,
      which were subsequently clustered and moved to MongoDB.`,
        `It's essentially a role-based application with several roles. The KHMC web portal houses patient records as well
      as medical and insurance-related tasks. While a DHR is a digital health record, it is used to display patient
      records and other specialized information in graphs and charts. Because of their internal use and rules, the
      portal's link cannot be displayed.`,
        `NodeJs, ExpressJs, ReactJs, WebRTC, Charts, and Redux were used as technologies.`,
      ],
      from: '2019',
      to: '2021',
    },
    {
      title: `Parkpnp`,
      links: [
        'https://www.linkedin.com/company/parkpnp/',
        'https://parkpnp.com/ie/',
        'https://play.google.com/store/apps/details?id=com.parkpnp',
      ],
      description: [
        `Parkpnp (Find your perfect parking space). Parkpnp is a web-based parking system that makes it simple for
        people to park their cars. It guarantees that you will never have to search for a parking space again. Find the
        perfect parking location among thousands of options.`,
        `The Parkpnp marketplace was the company's first product, a one-stop shop that connects all types of parking
        spot owners with motorists in need nearby. Local governments, parking firms, hotels, real estate companies,
        local businesses, and homeowners may all profit from their parking spaces thanks to our innovative strategy`,
        `Oauth, Ruby on Rails, PostgreSQL, Google maps, Styled component, ReactJs, AWS, Stripe for payment, Crisp live
        chat for conversation, and Heroku were used as technologies.`,
      ],
      from: '2018',
      to: '2020',
    },
    {
      title: `Intrack`,
      links: ['https://www.intrack.app/'],
      description: [
        `Intrack does downtime monitoring and real-time tracking script. It enables a sense of security for the
        customer's website.`,
        `Any website can be scanned and viewed its scripts on the dashboard, moreover, you'll be the first to know if
        your website is under attack.`,
        `Missing scripts and down websites will be notified in real-time via Slack and email.`,
        `My contributions to this app were designing and developing UI and architecting the database and API
        development and integrations.`,
        `Chartjs, NodeJs, ExpressJs, Angular, Vue, CloudShare, NuxtJs, Drift as chat features, were used as technologies
        and frameworks.`,
      ],
      from: '2018',
      to: '2019',
    },
    {
      title: `Fitbod`,
      links: ['https://fitbod.me/'],
      description: [
        `Fitbod's training algorithm analyses your strength-training capacity, analyses your previous workouts, and
       adapts to your gym equipment to create your custom-fit program.`,
        `It uses strength-training best practices to fill in the sets, repetitions, and weight for each exercise. Adjusts to
       push you a little harder in your next workout as you get stronger or master activities.`,
        `You can do the heavy lifting with Watch. Exercises are visible at a glance, and you can track your progress and
       keep focused while exercising.`,
        `It uses Angular, Node, Stripe, MongoDB`,
      ],
      from: '2017',
      to: '2018',
    },
    {
      title: `The Store Front `,
      links: [
        'https://www.thestorefront.com/',
        'https://www.linkedin.com/company/storefront/',
      ],
      description: [
        `Storefront is a digital platform that makes retail available to anybody in the world. We enable brands to sell
        their concept anywhere, space owners to activate their space with a single click, and consumers to purchase
        locally and globally`,
        `The application follows a straightforward three-step process. 1) The storefront offers flexible rentals in hightraffic, high-visibility regions to give your initiative the most exposure possible. 2) Look for spaces that fit your
        requirements. 3) The Storefront staff is ready to help, and Storefront offers assistance and assurances to make
        your short-term opening process go as smoothly as possible.`,
        `It uses NodeJs, AngluarJs, Mapbox GL Js, Google maps, AWS, Google optimize for A/B testing, Stripe for
        payments.`,
      ],
      from: '2016',
      to: '2017',
    },
  ],
  experience: [
    {
      title: 'Software Engineer - II',
      company: 'Kwanso',
      description: [
        `Identifying problems and common trends, as well as establishing standard operating procedures, can help to improve system consistency`,
        `Keeping current codebases up to date and updating them, as well as peer-reviewing code updates.`,
        `Collaborating with coworkers to put technological designs into action.
      Integrations with many third party support and libraries.`,
      ],
      from: 'Jan 2021',
      to: 'Present',
    },
    {
      title: 'Software Engineer - I',
      company: 'Systems Junction',
      description: [
        `Using hashing and indexing, I was able to store, retrieve, and manipulate up to half a million records.`,
        `Using the node ecosystem, modified existing software to correct errors and increase performance.`,
        `Enhanced applications through the identification of areas for development, the formulation of guidelines, and the design and implementation of programs.`,
        `Core responsibilities were to check and balance frontend and backend codebases with quality controls.`,
        `Held a volunteer position as a software engineer for the Meals on Wheels chapter. Handled programming duties including web design and record keeping.`,
        `Developed front-end ReactJs application and its backend for more than 1.7 years related to healthcare. Also worked on the Django application to ensure its frontend build on bootstrap and Jquery. It was basically a college application for a Japanese client.`,
        `Customized a web app to track all the endpoints and traffic using tools and technologies.`,
        ` Worked with 13+ team members to produce creative, efficient solutions.`,
      ],
      from: 'Oct 2017',
      to: 'Dec 2020',
    },
  ],
  education: [
    {
      degree: 'BSCS',
      school: 'Comsats University Islamabad, Lahore Campus',
      description: `Major Subjects: OOP, DSA, ML, Mathematics, Algorithms, AI, etc`,
      from: 'Sept 2012',
      to: 'Aug 2016',
      score: '3.23',
    },
  ],
  skills: [
    'fab fa-html5',
    'fab fa-css3-alt',
    'fab fa-js-square',
    'fab fa-react',
    'fab fa-node-js',
    'fab fa-sass',
    'fab fa-npm',
    'fab fa-python',
    'fas fa-gem',
    'fas fa-database',
  ],
  workflows: [
    'API development using NodeJs, NestJs, ExpressJs',
    'Databases: SQL, MongoDB, PostgreSQL',
    'Mobile-First, Responsive Design',
    ' Cross Browser Testing, Debugging',
    'Cross Functional Teams',
    'Agile Development, Scrum',
  ],
  email: 'ijazmudassir786@gmail.com',
  phone: '+923314068055',
  address: 'Shahdara, Lahore, Pakistan',
};
